module.exports = __webpack_public_path__ + "static/media/adweek.292eb13e.jpg";